// Global Imports
import React from "react";

// Design Imports
import "./Array.css";

const Ideal = (props) => {
    return (
        <>
            <div className="font-medium md:gap-2 flex-col mb-3 md:flex-row md:items-center">
                Ideal For:
            </div>
            <ul className="array">
                {
                    props.ideal?.map((line, i) => {
                        return (
                            <li key={i}>{line}</li>
                        );
                    })
                }
            </ul>

        </>

    );
}

export default Ideal;